import { defineStore } from "pinia";
import { ref } from "vue";

export const useTypesEffectStore = defineStore("tiposEfectos", () => {

  const objetosAllTypes = ref([
    { id: "Denunciado", nombre: "Denunciado" },
    { id: "Recuperado", nombre: "Recuperado" },
    { id: "Secuestrado", nombre: "Secuestrado" },
  ]);

  const objetosOnlySecuestrado = ref([{ id: "Secuestrado", nombre: "Secuestrado" }]);

  return {
    objetosAllTypes
  };
});
